import { Link } from "@tanstack/react-router";
import type { FC, ReactNode } from "react";
import { useBrand } from "../brand-provider";
import LogoutButton from "@/src/presentation/components/logout-button";
import NotificationBell from "@/src/presentation/components/notification-bell";

const SimpleHeader: FC<{ headerAction?: ReactNode }> = ({ headerAction }) => {
  const brand = useBrand();
  return (
    <header className="sticky top-0 z-50 border-b bg-white">
      <div className="container mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex w-full items-center justify-between">
          <Link to="/" className="text-lg font-bold">
            <span className="text-brand-accent">{brand.header.accentText}</span>
            <span className="text-black">{brand.header.normalText}</span>
          </Link>

          <nav className="flex items-center gap-x-8">
            <Link
              to="/dashboard/devices"
              className="text-sm font-medium text-gray-600 hover:text-brand-accent"
              activeProps={{ className: "text-brand-accent font-semibold" }}
            >
              Devices
            </Link>
            <Link
              to="/dashboard/settings"
              className="text-sm font-medium text-gray-600 hover:text-brand-accent"
              activeProps={{ className: "text-brand-accent font-semibold" }}
            >
              Settings
            </Link>
          </nav>

          <div className="flex items-center gap-x-4">
            {headerAction}
            <NotificationBell />
            <LogoutButton />
          </div>
        </div>
      </div>
    </header>
  );
};

export default SimpleHeader;
